
export default {
    data() {
        return {
            style: 'style="margin-top:5px;cursor: pointer;' +
                "outline: 0;" +
                "color: #fff;" +
                "background-color: #2d3748;" +
                "border-color: #2d3748;" +
                "display: inline-block;" +
                "font-weight: 400;" +
                "line-height: 1.5;" +
                "text-align: center;" +
                "border: 1px solid transparent;" +
                "padding: 6px 12px;" +
                "font-size: 16px;" +
                "border-radius: .25rem;" +
                'transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;"',
        };
    },

    methods: {
        formatarVariaveisEmail(corpo, lote_id, leilao_id) {

            console.log("INICIANDO FORMATACAO CORPO");
            console.log(corpo);

            if (corpo.includes("&lt;$botao_lote&gt;")) {
                console.log("Entrou no IF LINK LOTE");

                let link =
                    '<a target="_blank" ' +
                    this.style +
                    ' class="btn btn-primary" href="' +
                    process.env.MIX_VUE_APP_URL +
                    '/lote/' +
                    lote_id +
                    '">Abrir</a>';

                corpo = this.replaceAll(corpo, "&lt;$botao_lote&gt;", link);
            }

            if (corpo.includes("<$botao_lote>")) {
                console.log("Entrou no IF LINK LOTE");

                let link =
                    '<a target="_blank" ' +
                    this.style +
                    ' class="btn btn-primary" href="' +
                    process.env.MIX_VUE_APP_URL +
                    '/lote/' +
                    lote_id +
                    '">Abrir</a>';

                corpo = this.replaceAll(corpo, "<$botao_lote>", link);
            }

            if (corpo.includes("&lt;$botao_leilao&gt;")) {
                console.log("Entrou no IF LINK LEILAO");

                let link =
                    '<a target="_blank" ' +
                    this.style +
                    ' class="btn btn-primary" href="' +
                    process.env.MIX_VUE_APP_URL +
                    "/leilao/" +
                    leilao_id + "/lotes" +
                    '">Abrir</a>';

                console.log(link);

                corpo = this.replaceAll(corpo, "&lt;$botao_leilao&gt;", link);
            }

            if (corpo.includes("<$botao_leilao>")) {
                console.log("Entrou no IF LINK LEILAO");

                let link =
                    '<a target="_blank" ' +
                    this.style +
                    ' class="btn btn-primary" href="' +
                    process.env.MIX_VUE_APP_URL +
                    "/leilao/" +
                    leilao_id + "/lotes" +
                    '">Abrir</a>';

                console.log(link);

                corpo = this.replaceAll(corpo, "<$botao_leilao>", link);
            }

            if (corpo.includes("&lt;$num_leilao&gt;")) {
                console.log("Entrou no IF NUMERO LEILAO");

                corpo = this.replaceAll(corpo, "&lt;$num_leilao&gt;", leilao_id);
            }

            return corpo;
        },
    }
}